<template>
  <div class="main-container">
    <TheSideBar>
      <router-link :to="{ name: 'settingsFlexibee' }">
        Synchronizace flexibee
      </router-link>
      <router-link :to="{ name: 'settingsStatesList' }">
        Stavy
      </router-link>
      <router-link :to="{ name: 'settingsGroups' }">
        ACL Skupiny
      </router-link>
      <router-link :to="{ name: 'settingsCompanyTemplateList' }">
        Šablony
      </router-link>
      <router-link :to="{ name: 'settingsSamba' }">
        Samba
      </router-link>
      <hr class="separator" />
      <div v-if="addonsRoutes === false"
           style="text-align: center"
      >
        <i class="fas fa-sync-alt fa-spin"></i> addons loading...
      </div>
      <router-link v-for="routeDefinition in addonsRoutes"
                   :key="routeDefinition.label"
                   :to="routeDefinition.to"
      >
        {{ routeDefinition.label }}
      </router-link>
    </TheSideBar>
    <DataReady id="content">
      <router-view :key="$route.path"></router-view>
    </DataReady>
  </div>
</template>

<script>
import TheSideBar from 'CORE/components/side-bar/the-side-bar'
import DataReady from 'CORE/components/utilities/data-ready'
import axios from 'axios'
import { get } from 'lodash'

export default {
    name: 'PropertyTypesView',
    components: {
        TheSideBar,
        DataReady,
    },
    data() {
        return {
            addonsSettings: false,
        }
    },
    computed: {
        addonsRoutes() {
            if (this.addonsSettings === false) return false
            const routes = []
            for (const addon of this.addonsSettings) {
                for (const instance of get(addon, 'instances')) {
                    routes.push({
                        label: `${addon.name}: ${instance.name}`,
                        to: {
                            name: 'addonsSettings',
                            params: { addonId: addon.addon_id, instanceId: instance.instance_id },
                        },
                    })
                }
            }
            return routes
        },
    },
    async mounted() {
        this.addonsSettings = get(await axios.get('/workflow/settings/'), 'data.addons')
    },
}
</script>
